import React, { useState } from 'react';
import { toast, ToastContainer } from 'react-toastify';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import authService from '../../../services/authServices';
import { END_POINTS } from '../../../services/endpoint/endPoint';
const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const navigate = useNavigate();
  let {token} = useParams()

  const passwordChangeHandler = (e) => {
    setPassword(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(token, "reset pw token")
    // authService.resetPassword(token, password).then((res) => {
    authService.login(END_POINTS.resetPassword, {token:token, newPassword:password}).then((res) => {
      if (res.status === 200) {
        toast.success(res.data.message);
        navigate("/login");
      }
    }).catch((error) => {
      if (error.response) {
        toast.error(error.response.data.error);
      }
    });
  };

  return (
    <>
      <ToastContainer />
      <div className="forget-password-wrapper login_wraper">
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>New Password</label>
            <input type="password" minLength={4} className="form-control" placeholder="Enter new password" onChange={passwordChangeHandler} required />
          </div>
          <button type="submit" className="btn">Reset Password</button>
        </form>
      </div>
    </>
  );
};

export default ResetPassword;
